export const CreateFieldTexts = {
  mapSection: `Hai due modi per visualizzare il tuo terreno, puoi caricare un file kml,
        oppure disegnare il tuo terreno direttamente qui sulla piattaforma.
        Scegli una delle due modalità.`,
  genericInfo: `Inizia a creare il tuo terreno indicando il nome con il quale vuoi
        visualizzarlo e la prossima o attuale coltura`,
  subAreaDialogAddDescription:
    "Aggiungi le informazioni relative al sottoterreno e disegnalo sulla mappa",
  subAreaDialogEditDescription:
    "Modifica le informazioni relative al sottoterreno e disegnalo sulla mappa",
};
